import { Pencil } from 'lucide-react';
import { EditCellForm } from '~/components/ui/table';
import { MIN_POSITIVE_PRICE, MAX_PRICE } from '~/utils/moneyBounds';

type PriceEditControlProps = {
  isEditing: boolean;
  isEdited: boolean;
  defaultValue: number | null;
  onEditClick: () => void;
  onSubmit: (value: string) => void;
  onCancel: () => void;
  editTitle: string;
  editedTitle: string;
  editedAriaLabel: string;
  testId?: string;
  disabled?: boolean;
};

export function PriceEditControl({
  isEditing,
  isEdited,
  defaultValue,
  onEditClick,
  onSubmit,
  onCancel,
  editTitle,
  editedTitle,
  editedAriaLabel,
  testId,
  disabled = false,
}: Readonly<PriceEditControlProps>) {
  return (
    <>
      <button
        type="button"
        onClick={onEditClick}
        disabled={disabled}
        data-testid={testId}
        className={`relative cursor-pointer shrink-0 disabled:cursor-not-allowed disabled:opacity-50 ${isEdited ? 'text-amber-500 hover:text-amber-600' : 'text-neut-400 hover:text-success-500'}`}
        title={isEdited ? editedTitle : editTitle}
        aria-label={isEdited ? editedAriaLabel : editTitle}
      >
        <Pencil size={14} aria-hidden />
        {isEdited && (
          <span className="absolute -top-1 -right-1 w-2 h-2 rounded-full bg-amber-400 ring-1 ring-white" />
        )}
      </button>
      {isEditing && (
        <EditCellForm
          defaultValue={defaultValue ?? ''}
          editableType="number"
          min={MIN_POSITIVE_PRICE}
          max={MAX_PRICE}
          onSubmit={onSubmit}
          onCancel={onCancel}
          isSubmitting={disabled}
          popupPosition="below"
          testIds={testId ? { input: `${testId}-input` } : undefined}
        />
      )}
    </>
  );
}
